import { Component, Input, OnChanges } from '@angular/core';
import { VoltageSpeedHistoricalBaseline, VoltageSpeedStateSummary } from '../../voltage-with-speed.models';
import { buildHistoricalBaseline } from './historical-baseline.utils';

@Component({
  selector: 'app-voltage-speed-historical-baseline',
  templateUrl: './historical-baseline.component.html',
  styleUrls: ['./historical-baseline.component.css']
})
export class VoltageSpeedHistoricalBaselineComponent implements OnChanges {
  @Input() baselines: VoltageSpeedHistoricalBaseline[] = [];
  @Input() states: VoltageSpeedStateSummary[] = [];

  rows: ReturnType<typeof buildHistoricalBaseline> = [];

  ngOnChanges(): void {
    this.rows = buildHistoricalBaseline(this.baselines, this.states);
  }
}
